import Cookies from 'js-cookie';
import { useAnalyticsPushEvent } from '../../../analytic/analytic.context';
import { makeFullUrl } from '../../../utils/analitic.utils';
import bem from '../../../utils/bem';

const CtaLink = ({
  fieldCta,
  fieldStyleCtaLink,
  base,
  mods,
  block,
  extra,
  onClickAnalyticData,
  attributes,
}) => {
  const pushAnalyticEvent = useAnalyticsPushEvent();
  const cta = fieldCta[0];
  const style =
    fieldStyleCtaLink && fieldStyleCtaLink.length
      ? fieldStyleCtaLink[0].value
      : false;
  const linkModsUsed = mods?.length ? mods : ['secondary'];
  let linkClasses = '';
  if (style === 'link') {
    linkClasses = bem(
      'link',
      ['black', 'arrow'],
      block || '',
      extra || ['mega-menu__link'],
    );
  } else {
    linkClasses = bem(
      base || 'btn',
      mods?.length ? linkModsUsed : linkModsUsed.concat(['s']),
      block || '',
      extra || ['mega-menu__link'],
    );
  }

  const onClickAnalyticPush = (item) => {
    if (!onClickAnalyticData) return undefined;
    switch (onClickAnalyticData?.event) {
      case 'nav_clicked':
        return pushAnalyticEvent({
          ...onClickAnalyticData,
          link_text: onClickAnalyticData?.link_text || item.title,
          link_url: makeFullUrl(item.url),
        });
      case 'find_a_pro_profile_clicked':
        // Set cookies for node company location analytics.
        Cookies.set(
          'vendor_called_product_category_analytics',
          onClickAnalyticData.product_category,
          {
            path: item.url,
          },
        );
        Cookies.set(
          'vendor_called_zip_code_analytics',
          onClickAnalyticData.zip_code,
          {
            path: item.url,
          },
        );

        return pushAnalyticEvent({
          ...onClickAnalyticData,
          link_url: makeFullUrl(item.url),
        });
      default:
        return undefined;
    }
  };

  return (
    <a
      className={linkClasses}
      href={cta.url}
      onClick={() => {
        onClickAnalyticPush(cta);
      }}
      {...attributes}
    >
      {cta.title}
    </a>
  );
};

export default CtaLink;
